import { useMediaQuery } from './useMediaQuery';

// Matches the app's one existing mobile signal (App.css's
// .mobile-module-warning breakpoint) so "mobile" means the same viewport
// width everywhere in the codebase.
const MOBILE_QUERY = '(max-width: 767px)';

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
